import script from "./HistoryGames.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryGames.vue?vue&type=script&setup=true&lang=js"

import "./HistoryGames.vue?vue&type=style&index=0&id=e91dd620&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e91dd620"]])

export default __exports__